module.exports = __webpack_public_path__ + "static/media/icon-emoji-puzzled.5e72b8f8.png";